import { State, Action } from "./types";

export function reducer(state: State, action: Action): State {
  const actionType = action.type;

  switch (action.type) {
    // * Data state
    case "LOAD_OCCURRENCES": // 1
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        isComposed: false,
        isProcessed: false,
      };
    case "LOAD_OCCURRENCES_SUCCESS": // 2
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        rawData: action.rawData,
      };
    case "SET_COMPOSED_GROUPED_OCCURRENCES": // 3
      return {
        ...state,
        composedOccurrences: action.composedOccurrences,
        composedOccurrencesBySite: action.composedOccurrencesBySite,
        isComposed: true,
      };
    case "SET_COMPOSED_FILTERED_OCCURRENCES": // 4
      return {
        ...state,
        composedFilteredOccurrences: action.composedFilteredOccurrences,
        search: action.search,
      };
    case "SET_COMPOSED_AND_GROUPED_INSIGHTS":
      return {
        ...state,
        composedAndGroupedInsights: action.composedAndGroupedInsights,
      };
    case "SET_PROCESSED_INSIGHTS":
      return {
        ...state,
        composedAndGroupedOccurrences: action.occurrences,
        composedAndGroupedInsights: action.insights,
        isProcessed: true,
      };

    // * UI State
    case "SET_SORT_DIRECTION":
      return { ...state, sortDirection: action.direction };
    case "SET_GROUP_BY":
      return { ...state, groupBy: action.groupBy };
    case "SET_SORT_BY":
      return { ...state, sortBy: action.sortBy };
    case "TOGGLE_EXPAND_ALL":
      return { ...state, expandAll: !state.expandAll };
    case "SET_CATEGORY":
      return { ...state, category: action.category };
    default:
      throw new Error(`Unhandled action type: ${actionType}`);
  }
}
